import { useEffect, useState } from "react";
import { Table, Space, Button } from "antd";
import axios from "axios";
import { api } from "../../../api/url";

// --------------- style
import "./style.css";
import { number_3_3 } from "../../../utilities";

const columns = [
  {
    title: "شناسه مرجع",
    dataIndex: "refNo",
    key: "name",
    render: (text) => <a>{text ? text : "-"}</a>,
  },
  {
    title: "شناسه نوبت",
    dataIndex: "admissionId",
    key: "admissionId",
    render: (text) => <a>{text ? text : "-"}</a>,
  },
  {
    title: "تاریخ ثبت",
    dataIndex: "createDateTimePersian",
    key: "age",
  },
  {
    title: "وضعیت",
    dataIndex: "inOut",
    key: "status",
    render: (_, record) =>
      record.confirmed === true ? (
        <a className="success">پرداخت</a>
      ) : (
        <a className="pending-transaction">درانتظار پرداخت</a>
      ),
  },
  {
    title: "مبلغ",
    dataIndex: "cashAmount",
    key: "address",
    render: (_, record) => (
      <Space size="middle">
        <a>{number_3_3(record.cashAmount)}</a>
        <a>ریال</a>
      </Space>
    ),
  },
  // {
  //   title: "عملیات",
  //   key: "action",
  //   dataIndex: "status",
  //   render: (_, record) =>
  //     record.confirmed === true ? null : (
  //       <Button>
  //         <a className="success">پرداخت</a>
  //       </Button>
  //     ),
  // },
];

const UserHistory = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);

  const GetTransaction = async () => {
    await axios({
      method: "post",
      url: api + "appointment/user/getappointmentcash/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      data: {
        pageNo: 10 * page,
        pageRowsCount: 100,
        appointmentUserId: localStorage.getItem("user"),
      },
    })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetTransaction();
  }, []);

  return (
    <Table
      pagination={{
        pageSize: 10,
      }}
      style={{
        paddingBottom: 100
      }}
      className="userhistory-table"
      rootClassName="userhistory-table"
      columns={columns}
      dataSource={data}
    />
  );
};

export default UserHistory;
